import {
  faPlay,
  faPlus,
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCheck,
  faDownload,
  faWrench,
  faTrash,
  faExclamation,
  faTimes,
  faClock,
  faSearch,
  faPaperPlane,
  faPhoneAlt,
  faCog,
  faUser,
  faFilePdf,
  faInfoCircle,
  faExternalLinkAlt,
  faPen,
  faPlusCircle,
  faGraduationCap,
  faBook,
  faProjectDiagram,
  faRulerCombined,
  faPause,
  faTimesCircle,
  faComments,
  faTools,
  faWifi,
  faStar,
  faBell,
  faRedo,
  faSortDown,
  faSortUp,
  faExclamationTriangle,
  faMapMarkerAlt,
  faFilter,
  faKey,
  faUndo,
  faBolt,
  faPaperclip,
  faUpload
} from '@fortawesome/free-solid-svg-icons'

import {faThumbsUp as fasThumbsUp} from '@fortawesome/free-solid-svg-icons'
import {faThumbsDown as fasThumbsDown} from '@fortawesome/free-solid-svg-icons'

import {
  faUserHardHat,
  faLockAlt,
  faShieldCheck,
  faCalendarExclamation,
  faBooks
} from '@fortawesome/pro-solid-svg-icons'

import {faThumbsUp as falThumbsUp} from '@fortawesome/pro-light-svg-icons'
import {faThumbsDown as falThumbsDown} from '@fortawesome/pro-light-svg-icons'
import {faPlus as falPlus} from '@fortawesome/pro-light-svg-icons'
import {faTimes as falTimes} from '@fortawesome/pro-light-svg-icons'

import {
  faSignOutAlt,
  faWindowMinimize,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/pro-regular-svg-icons'

export default {
  faPlay,
  faPlus,
  falPlus,
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faChevronLeft,
  faChevronRight,
  faCheck,
  faDownload,
  faWrench,
  faTrash,
  faExclamation,
  faTimes,
  falTimes,
  faClock,
  faSearch,
  faSignOutAlt,
  faPaperPlane,
  faPhoneAlt,
  faCog,
  faUser,
  faFilePdf,
  faInfoCircle,
  faExternalLinkAlt,
  faPen,
  faGraduationCap,
  faBook,
  faBooks,
  faProjectDiagram,
  faUserHardHat,
  faRulerCombined,
  faKey,
  faPause,
  faUndo,
  faTimesCircle,
  falThumbsUp,
  falThumbsDown,
  fasThumbsUp,
  fasThumbsDown,
  faComments,
  faTools,
  faWifi,
  faStar,
  faBell,
  faRedo,
  faSortDown,
  faSortUp,
  faWindowMinimize,
  faExclamationTriangle,
  faLockAlt,
  faShieldCheck,
  faMapMarkerAlt,
  faPlusCircle,
  faCalendarExclamation,
  faFilter,
  faBolt,
  faPaperclip,
  faUpload
}
